export var InlineContentDisplayStyle;

(function (InlineContentDisplayStyle) {
  InlineContentDisplayStyle["Block"] = "block";
  InlineContentDisplayStyle["Inline"] = "inline";
})(InlineContentDisplayStyle || (InlineContentDisplayStyle = {}));